/*
 * These set of actions coordinate depending on the documentGroups defined the different requests that should be made.
 * We have three kind of different documentGroups:
 * -Extractos-open
 * -Document-manager
 * -Combined
 * The tricky ones being the combined groups:
 * -Both do server side filtering.
 * -Both have a 'category' filter.
 * -Combination is done on a reducer level by hiding oldest document-manager documents. These do not paginate. hasMore ='N' Always.
 * @Refactored: alejandro.delavina@gruposantander.com
 * @Date: 20/05/2018
 */



// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
import { VIEWER } from 'constants/contactCenter/pdfViewer';
const { DOCUMENT_TYPE_COST_BREAKDOWN } = require('constants/documents');
const {
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR, CONTENT_TYPE_PDF, CONNECTION_CHANNEL_CONTACT_CENTER, BROKER_ORDER_TYPE_BUY, TYPE_WARRANTS, TYPE_FUNDS
} = require('constants/index');
const { BUY_SELL_ORDER_TYPE, SEND_ORDER } = require('constants/contactCenter/brokerFundsSendEmailConstants');
const contactCenterActionTypes = require('constants/contactCenter/actionTypes');
const { HASHED_DOC_GROUP } = require('constants/documentsGroups');
const codCategoria = '0001';

// @ helpers
const { download } = require('utilities/fileDownloadHelper');
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const { getEmail } = require('utilities/personalDataHelper');
import { openPDFViewer, showPDFFailure } from 'utilities/contactCenter/pdfViewer';

// @ actions
const { fetchMyInvestments } = require('actions/brokerMyInvestments');


const resetDocuments = () => ({
    type: actionTypes.FETCH_DOCUMENTS_RESET
});

const requestMoreDocumentsInProgress = () => ({
    type: actionTypes.FETCH_MORE_DOCUMENTS_REQUEST
});


const requestMoreDocumentsSuccess = data => ({
    type: actionTypes.FETCH_MORE_DOCUMENTS_SUCCESS,
    payload: {
        data
    }
});

const requestGenericDocumentsInProgress = () => ({
    type: actionTypes.FETCH_GENERIC_DOCUMENTS_REQUEST
});
const requestGenericDocumentsSuccess = data => ({
    type: actionTypes.FETCH_GENERIC_DOCUMENTS_SUCCESS,
    payload: {
        data
    }
});

const requestGenericDocumentsFailure = error => ({
    type: actionTypes.FETCH_GENERIC_DOCUMENTS_FAILURE,
    payload: {
        error
    }
});


const requestOkApiDocumentsInProgress = () => ({
    type: actionTypes.FETCH_OK_API_DOCUMENTS_REQUEST
});
const requestOkApiDocumentsSuccess = data => ({
    type: actionTypes.FETCH_OK_API_DOCUMENTS_SUCCESS,
    payload: {
        data
    }
});

const requestOkApiDocumentsFailure = error => ({
    type: actionTypes.FETCH_OK_API_DOCUMENTS_FAILURE,
    payload: {
        error
    }
});

const getNextGenericDocumentPage = () => ({
    type: actionTypes.GET_NEXT_GENERIC_DOCUMENT_PAGE
});

const requestMoreDocumentsFailure = error => ({
    type: actionTypes.FETCH_MORE_DOCUMENTS_FAILURE,
    payload: {
        error
    }
});

const requestDocumentsPdfInProgress = codComunicacion => ({
    type: actionTypes.FETCH_DOCUMENTS_PDF_REQUEST,
    payload: {
        codComunicacion
    }
});

const requestDocumentsPdfSuccess = (data, codComunicacion) => ({
    type: actionTypes.FETCH_DOCUMENTS_PDF_SUCCESS,
    payload: {
        data,
        codComunicacion
    }
});

const requestDocumentsPdfFailure = codComunicacion => ({
    type: actionTypes.FETCH_DOCUMENTS_PDF_FAILURE,
    payload: {
        codComunicacion
    }
});


const setDocumentsFilter = filters => ({
    type: actionTypes.FETCH_DOCUMENTS_FILTER, // tagged for analytics
    payload: {
        filters
    }
});

const clearDocumentsFilter = () => ({
    type: actionTypes.FETCH_DOCUMENTS_FILTER_CLEAR // tagged for analytics
});

const resetDocumentsFilter = (filterKey) => ({
    type: actionTypes.FETCH_DOCUMENTS_FILTER_RESET,
    payload: {
        filterKey
    }
});

const setGroupSelected = groupSelected => ({
    type: actionTypes.FETCH_DOCUMENTS_GROUP_CHANGE,
    payload: {
        groupSelected
    }
});


/**
 * This function fetchs documents from the server using the endpoint stored in
 * "memento". When you need to clear the list because you are applying a filter
 * (or removing it), you need to set the "isFiltering" parameter to true.
 *
 * @param  {Boolean} isFiltering It resets the list when applying a filter.
 */
const requestMoreContractDocuments = (customGroupName) => (dispatch, getState) => {

    const immDocuments = getState().documents;
    const groupSelected = customGroupName ? customGroupName : immDocuments.get('groupSelected');
    const documentsByGroup = immDocuments.get('documentsByGroup');

    let oldDocuments = groupSelected === '0033' ? getState().additionalDocumentation.get('additionalDocumentation') : [];
    const group = documentsByGroup.get(groupSelected);

    const from = immDocuments.getIn(['filters', 'date', 'from']);
    const to = immDocuments.getIn(['filters', 'date', 'to']);
    const accountIdSelected = immDocuments.getIn(['filters', 'account', 'number']);
    const accountSelected = getState().accounts.getIn(['byId', accountIdSelected]);
    const typeOfDocument = immDocuments.getIn(['filters', 'typeOfDocument', 'type']);

    let query = {
        codCategoria: codCategoria,
        codGrupoComunicacion: groupSelected === '0000' || groupSelected === '0022' ? '' : groupSelected
    };

    if(group !== undefined && group.get('hasMore') === 'S' && group.get('memento'))
    {
        query.memento = group.get('memento');
        query.hasMorePagination = group.get('hasMore');
    }

    if (Boolean(from)) {
        query.fechaDesde = from.format('YYYY-MM-DD');
    }

    if (Boolean(to)) {
        query.fechaHasta = to.format('YYYY-MM-DD');
    }

    if (Boolean(accountIdSelected)) {
        query.producto = accountSelected.get('newProduct');
        query.numeroContrato = accountSelected.get('newContractNumber');
    }

    if (Boolean(typeOfDocument)) {
        query.codTipoComunicacion = typeOfDocument;
    }

    const requestData = { query };

    dispatch(requestMoreDocumentsInProgress());
    const formatDocumentsByGroup = (documents)=>{
        if(groupSelected === '1133'){
            return documents.map(document=>({...document, documentType: document.documentTypeId}))
        }
        return documents
    }
    APIGet(dispatch, apiURLBuilder.getURL('requestDocuments'), requestData).then(
        response => {
            let formattedResponse = {};

            formattedResponse[groupSelected] = {
                documents: [...oldDocuments, ...formatDocumentsByGroup(response.datos.datos)],
                hasMore: response.hasMore,
                memento: response.memento
            };
            dispatch(requestMoreDocumentsSuccess(formattedResponse));
        },
        error => {
            const erroCode = error.body.error;

            switch (erroCode) {
                case 'WSEXTR_0001':
                    let formattedResponse = {};
                    formattedResponse[groupSelected] = {
                        documents: [],
                        hasMore: 'N',
                        memento: ''
                    };
                    dispatch(requestMoreDocumentsSuccess(formattedResponse));
                    break;
                default:
                    dispatch(requestMoreDocumentsFailure(error));
                    break;
            }
        }
    );
};

const fetchDocumentsGenericAndComunications = (groupSelected, customGroupName) => dispatch => {
    let requestDataGeneric = {
        query: {
            category: groupSelected
        }
    };
    const query = {
        codCategoria: '0001',
        codGrupoComunicacion: customGroupName
    }
    let oldDocuments = [];
    const requestData = { query };
    return APIGet(dispatch, apiURLBuilder.getURL('getGenericDocuments'), requestDataGeneric)
        .then(response => {
            APIGet(
                dispatch,
                apiURLBuilder.getURL("requestDocuments"),
                requestData
            )
            .then((responseDms) => {
                dispatch(requestGenericDocumentsSuccess({
                    documents: response,
                    groupSelected
                }));
                let formattedResponse = {};
                formattedResponse[groupSelected] = {
                    documents: [...oldDocuments, ...responseDms.datos.datos],
                    hasMore: responseDms.hasMore,
                    memento: responseDms.memento
                };
                dispatch(requestMoreDocumentsSuccess(formattedResponse));

            })
            .catch((error) => {
                dispatch(requestGenericDocumentsSuccess({
                    documents: response,
                    groupSelected
                }));
            });
        })
        .catch(error => dispatch(requestGenericDocumentsFailure(error)));
}

const getApplicationDocumentsOkApi =
    (immDocuments, queryParams={}, callBack) => (dispatch) => {
        dispatch(requestOkApiDocumentsInProgress());
        const from = immDocuments.getIn(["filters", "date", "from"]);
        const to = immDocuments.getIn(["filters", "date", "to"]);
        let requestData = {
            query: queryParams
        };

        if (Boolean(from)) {
            requestData.query.startDate =
                from.format("YYYY-MM-DDT00:00:00.000") + "Z";
        }

        if (Boolean(to)) {
            requestData.query.endDate =
                to.format("YYYY-MM-DDT23:59:59.000") + "Z";
        }

        return APIGet(
            dispatch,
            apiURLBuilder.getURL("apiDocumentsApplication"),
            requestData
        )
            .then((response) => {
                if (response) {
                    dispatch(requestOkApiDocumentsSuccess(response));
                } else {
                    dispatch(requestOkApiDocumentsFailure());
                    callBack && callBack();
                }
            })
            .catch((error) => {
                dispatch(requestOkApiDocumentsFailure(error));
                callBack();
            });
    };

const fetchGenericDocuments = (immDocuments, groupSelected) => (dispatch) => {
    const from = immDocuments.getIn(['filters', 'date', 'from']);
    const to = immDocuments.getIn(['filters', 'date', 'to']);
    let requestData = {
        query: {
            category: groupSelected
        }
    };

    //If group is everything, then do not specify filtering.
    if(groupSelected === '0000') {
        delete requestData.query.category;
    }

    //If group is pension plans, then it is filtered by the category plans.
    if(groupSelected === '0045') {
        requestData.query.category = "PLANES";
    }

    if(groupSelected === '1133') {
        const queryParams = {
            application: 'cat_certificados_canal',
            uploadStatus: 'UPLOADED',
            clientVisible: true,
          };
          return dispatch(getApplicationDocumentsOkApi(immDocuments, queryParams));
    }

    if (Boolean(from)) {
        requestData.query.fromDate = from.format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);
    }

    if (Boolean(to)) {
        requestData.query.toDate = to.format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);
    }
    dispatch(requestGenericDocumentsInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL('getGenericDocuments'), requestData)
            .then(response => {

                dispatch(requestGenericDocumentsSuccess({
                        documents: response,
                        groupSelected
                    }));
            })
            .catch(error => dispatch(requestGenericDocumentsFailure(error)));
}


const fetchCostBreakdownSuccess = response => ({
    type: contactCenterActionTypes.DOCUMENTATION_MIFID_COST_BREAKDOWN_SUCCESS,
    payload: Object.assign({}, response)
});

const requestCostBreakdownDocumentsInProgress = () => ({
    type: contactCenterActionTypes.DOCUMENTATION_MIFID_COST_BREAKDOWN_FETCHING,
});

const setSelectedDocument = (selectedDocument) => ({
    type: contactCenterActionTypes.SET_SELECTED_DOCUMENT,
    payload: selectedDocument
});

const fetchCostBreakdownForBrokerProducts = (groupSelected, isinArray) => (dispatch) => {
    const orderType = BROKER_ORDER_TYPE_BUY;
    const documentType = DOCUMENT_TYPE_COST_BREAKDOWN;

    const createPromise = (isin) => {
        return new Promise(resolve => {

            const data = {
                "documentType": documentType,
                "isin": isin,
                "orderType": orderType
            };

            const requestData = {
                query: data
            };

            APIPost(dispatch, apiURLBuilder.getURL('getProductCost'), requestData).then(
                (response) => {
                    return resolve({ response });
                })
                .catch(response => {
                    if (response && response.error) {
                        return resolve({ response: null });
                    } else {
                        throw response;
                    }
                });
        })
    };

    if (!isinArray.length) {
        return dispatch(fetchCostBreakdownSuccess({
            data: {
                groupSelected,
                mifidAllDocuments: []
            }
        }));
    }

    const promises = isinArray.map((item) => {
        return createPromise(item);
    });

    return Promise.all(promises)
        .then(values => {
            const mifidAllDocuments = values.filter(item => (item.response && item.response.objectId)).map(item => ({
                documentType: DOCUMENT_TYPE_COST_BREAKDOWN,
                isin: item.response.isin,
                objectId: item.response.objectId
            }));

            dispatch(fetchCostBreakdownSuccess({
                data: {
                    groupSelected,
                    mifidAllDocuments
                }
            }));
        });
};

const uniqueArray = arrArg => {
    return arrArg.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
    });
};

const retrieveIsinArray = immStocksByType => {
    let isinArray = [];

    immStocksByType.map((product, productName) => {
        if (productName === TYPE_FUNDS || productName === TYPE_WARRANTS) {
            product.get('stocks').map(stock => {
                if (stock.get('isin')) {
                    isinArray.push(stock.get('isin'));
                }
            });
        }
    });

    return uniqueArray(isinArray);
};

const fetchCostBreakdownDocuments = groupSelected => (dispatch, getState) => {
    dispatch(requestCostBreakdownDocumentsInProgress());

    const myInvestmentsPromise = dispatch(fetchMyInvestments());
    const resultPromise = myInvestmentsPromise ? myInvestmentsPromise : Promise.resolve();
    return resultPromise
        .then(() => {
            const immBrokerMyInvestments = getState().brokerMyInvestments;
            const immStocksByType = immBrokerMyInvestments.get('products');
            const isinArray = retrieveIsinArray(immStocksByType);

            dispatch(fetchCostBreakdownForBrokerProducts(groupSelected, isinArray));
        })
        .catch(error => dispatch(requestMoreDocumentsFailure(error)));
};

/**
 * This function works for Generic documents.
 * Either makes a first network request, or just populate next page documents.
 *
 * @param  {Boolean} isShowMore informs that request triggered because of show more
 */
const requestMoreGenericDocuments = () => (dispatch, getState) => {
    const immDocuments = getState().documents;
    const groupSelected = immDocuments.get('groupSelected');
    dispatch(fetchGenericDocuments(immDocuments, groupSelected));

    if (__CONTACT_CENTER__ && groupSelected === 'MIFID2') {
        dispatch(fetchCostBreakdownDocuments(groupSelected));
    }
};



/**
 * This function routes the request of fectching document to the proper function.
 *
 */

const requestMoreDocuments = (isShowMore) => (dispatch, getState) => {
    const immDocuments = getState().documents;
    const groupSelected = immDocuments.get('groupSelected');
    const documentsByGroup = immDocuments.get('documentsByGroup');
    const allDocumentsAlreadyFetched = Boolean(documentsByGroup.get(groupSelected)) && !!HASHED_DOC_GROUP[groupSelected].paginateLocally;
    const shouldRequestMoreDocuments = !Boolean(documentsByGroup.get(groupSelected)) || isShowMore;

    if (shouldRequestMoreDocuments && !allDocumentsAlreadyFetched) {

        if (isNaN(groupSelected)) {
            if(groupSelected === "ROBO") {
                dispatch(fetchDocumentsGenericAndComunications(groupSelected, 'INVE'));
            } else if(groupSelected === "testmifid") {
              dispatch(fetchDocumentsGenericAndComunications(groupSelected, 'SUIT'))
            } else if(groupSelected === "accountdsc") {
                dispatch(fetchDocumentsGenericAndComunications(groupSelected, 'ADSC'))
            } else {
                dispatch(requestMoreGenericDocuments());
            }
        } else if ( groupSelected === '0000' || groupSelected === '0045' ||groupSelected === '1133' ) {
            // When the selected group is 'all the groups' and 'pension plans', we proceed to call both services
            dispatch(requestMoreContractDocuments());
            if(!isShowMore) {
                dispatch(requestMoreGenericDocuments());
            }
        }  else {
            // change in state 'groupSelected' will cause appropriate data picked from documentGroup map
            dispatch(requestMoreContractDocuments());
        }
    }
    else if (allDocumentsAlreadyFetched) {
        dispatch(getNextGenericDocumentPage());
    }
};


const requestDocumentsPdf = data => (dispatch, getState) => {
    const isAlreadyFetching = getState().documents.get('isFetching');

    if (!isAlreadyFetching) {
        const params = {
            query: {
                gestorDocumental: data.gestorDocumental,
                codigoSubaplicacion: data.codigoSubaplicacion,
                codComunicacion: data.codComunicacion
            },
            header: {
                accept: 'application/pdf', // If you are copying and pasting this. Try removing this line.  @javo
                responseType: 'arraybuffer'
            }
        };

        dispatch(requestDocumentsPdfInProgress(data.codComunicacion));

        return APIGet({
            dispatch,
            params,
            endpoint: 'requestDocumentsPdf'
        })
        .then(response => {
            download(response.xhr.response, 'extracto.pdf', 'application/pdf');
            dispatch(requestDocumentsPdfSuccess(response, data.codComunicacion));
        })
        .catch(error => dispatch(requestDocumentsPdfFailure(error, data.codComunicacion)));
    }
};


const requestMifid2DocumentsPdf = (data, loadType = undefined) => (dispatch) => {

        const params = {
            query: {
                objectId: data.codComunicacion
            }
        };

        dispatch(requestDocumentsPdfInProgress(data.codComunicacion));

        return APIGet(dispatch, apiURLBuilder.getURL('getDocumentContent'), params)
                .then(response => {
                    let base64String = `data:${CONTENT_TYPE_PDF};base64,${response.content}`;
                    if (!loadType) {
                        downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, data.fileName || data.codComunicacion);
                    } else if (loadType === VIEWER) {
                        openPDFViewer(base64ToBlob(base64String), CONTENT_TYPE_PDF, data.codComunicacion);
                    }

                    dispatch(requestDocumentsPdfSuccess(response, data.codComunicacion));
                })
                .catch(error => {
                    if (loadType === VIEWER) {
                        showPDFFailure();
                    }
                    dispatch(requestDocumentsPdfFailure(error, data.codComunicacion));
                });

};

const sendMifid2DocumentByEmailRequest = data => ({
    type: contactCenterActionTypes.MIFID_DOCUMENTS_SEND_MAIL_REQUEST,
    payload: Object.assign({}, data)
});

const sendMifid2DocumentByEmailSuccess = data => ({
    type: contactCenterActionTypes.MIFID_DOCUMENTS_SEND_MAIL_REQUEST_SUCCESS,
    payload: Object.assign({}, data)
});

const sendMifid2DocumentByEmailFailure = data => ({
    type: contactCenterActionTypes.MIFID_DOCUMENTS_SEND_MAIL_REQUEST_ERROR,
    payload: Object.assign({}, data)
});

const sendMifid2DocumentByEmail = params => (dispatch, getState) => {
    dispatch(sendMifid2DocumentByEmailRequest({ objectId: params.objectId }));

    const immProfile = getState().profile;
    const email = getEmail(immProfile);

    const requestData = {
        query: {
            "channel": CONNECTION_CHANNEL_CONTACT_CENTER,
            "orderType": BUY_SELL_ORDER_TYPE,
            "email": email,
            "sendOrder": SEND_ORDER,
            "costBreakdown": params.objectId
        }
    };

    return APIPost(dispatch, apiURLBuilder.getURL('communication'), requestData)
        .then(() => dispatch(sendMifid2DocumentByEmailSuccess({ objectId: params.objectId, email })))
        .catch(response => {
            if (response.error) {
                dispatch(sendMifid2DocumentByEmailFailure({ objectId: params.objectId, error: response.error }));
            } else {
                throw response;
            }
        });
};

const mifid2DocumentSendEmailReset = () => ({
    type: contactCenterActionTypes.MIFID_DOCUMENTS_SEND_MAIL_RESET,
});

module.exports = {
    resetDocuments,
    requestMoreDocuments,
    requestDocumentsPdf,
    requestMifid2DocumentsPdf,
    resetDocumentsFilter,
    clearDocumentsFilter,
    setDocumentsFilter,
    setGroupSelected,
    sendMifid2DocumentByEmail,
    mifid2DocumentSendEmailReset,
    getNextGenericDocumentPage,
    setSelectedDocument,
    getApplicationDocumentsOkApi

};
